import { QuestionTypes, QuestionnaireComponent } from "dynamic-questionarie";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import Service from "../services";
import { AxiosError, AxiosResponse } from "axios";
import { Question } from "dynamic-questionarie/dist/esm/models/QuestionarieModel";
import { ParseJson, catchError } from "../utils/Utils";
import { IPostQuestionData } from "../models/SharedModel";
import { BankUserContext } from "../bankUserContext";
import "../scss/subCategory.scss";
import backArrow from "../images/backArrow.svg";
import { IActionBtnsModel } from "../models/StatusTabModel";
import { QUESTIONNAIRE_TYPES } from "../utils/RoutesUtil";
import FinSpinner from "../commonfields/FinSpinner";
import { catchErrorGeneric } from "../utils/GeneralUtils";
import ReactFileViewer from "../commonfields/ReactFileViewer";
import { APP_Config } from "../utils/AppConfig";

export default function QuestionnariePage() {
  const service = useMemo(() => new Service(), []);
  const navigate = useNavigate();
  const { type, clientId, clientProductsId } = useParams();
  const { bankuserDetails } = useContext(BankUserContext);
  const [questionnaireData, setQuestionnaireData] = useState<any>(null);
  const [loader, setLoader] = useState(false);
  const [refreshQuestionsData, setrefreshQuestionsData] = useState(false);
  const [showAIModal, setShowAImodal] = useState(false);
  const [question, setQuestion] = useState<Question>();
  const [filteredQuestions, setFilteredQuestions] = useState<any>();
  const [fileHandleModal, setfileHandleModal] = useState<boolean>(false);
  const [file, setFile] = useState<any>(null);
  const location = useLocation();
  const edit = location.state;
  const questionIds = APP_Config().REACT_APP_QUESTIONIDS_FOR_6TH_MONTH_PROCESSING;;
  const questionId = APP_Config().REACT_APP_QUESTIONID_FOR_CURRENCY_6TH_MONTH_PROCESSING;;
  const averageAmount = 1000000;

  const setQuestionsData = (res: any) => {
    const newReponses = res?.data?.questionResponses?.map((each: any) => ({
      ...each,
      answers: each?.answers || [],
    }));
    setQuestionnaireData(newReponses || []);
    if (type?.toLowerCase() === QUESTIONNAIRE_TYPES.PAYMENT?.toLowerCase()) {
      const filteredQuestion = newReponses?.find(
        (m: Question) => m.questionId === questionId
      );

      // filteredQuestion && checkForAnsweredQuestionValidation(filteredQuestion);
      if(filteredQuestion && filteredQuestion.questionId === questionId && filteredQuestion.answers){
        if(parseInt(filteredQuestion?.answers[0].answer.slice(1).split(",").join(""))<averageAmount){
          const questions=newReponses.filter((m:any)=>!questionIds.includes(m.questionId));
          deleteFile(newReponses);
          setQuestionnaireData(questions);

        }

      }
      const filteredQuestions = newReponses?.filter((m: Question) =>
        questionIds?.includes(m?.questionId)
      );
      setFilteredQuestions(filteredQuestions);
    }
  };

  const getQuestions = useCallback(() => {
    if (clientId && clientProductsId) {
      if (type?.toLowerCase() === QUESTIONNAIRE_TYPES.NDA?.toLowerCase()) {
        service
          .getNdaPrequalQuestions(clientId, clientProductsId)
          .then((res: AxiosResponse) => setQuestionsData(res))
          .catch((err) => catchError(err, true));
      }
      if (type?.toLowerCase() === QUESTIONNAIRE_TYPES.CONTRACT?.toLowerCase()) {
        service
          .getContractPrequalQuestions(clientId, clientProductsId)
          .then((res: AxiosResponse) => setQuestionsData(res))
          .catch((err) => catchError(err, true));
      }
      if (type?.toLowerCase() === QUESTIONNAIRE_TYPES.DDA?.toLowerCase()) {
        service
          .getDdaPrequalQuestions(clientId, clientProductsId)
          .then((res: AxiosResponse) => setQuestionsData(res))
          .catch((err) => catchError(err, true));
      }
      if (type?.toLowerCase() === QUESTIONNAIRE_TYPES.PAYMENT?.toLowerCase()) {
        service
          .getPaymentPrequalQuestions(clientId, clientProductsId)
          .then((res: AxiosResponse) => {
            setQuestionsData(res);
          })
          .catch((err) => catchError(err, true));
      }
    }
  }, [clientId, clientProductsId, type]);

  const saveClientResponse = (question: Question) => {
    const payload: IPostQuestionData = {
      answer: "",
      clientQuestionId: question?.clientQuestionId,
      options: [],
      requireCopy: false,
    };
    payload.answer = question?.answers?.[0]?.answer || "";
    if (question.options.length > 0) {
      payload.options =
        question?.answers?.map((item) => ({
          questionOptionId: item.optionId,
          answer: item.answer,
        })) || [];
    }
    service.saveClientResponse(payload).catch((err) => catchError(err, true));
  };

  const modalViewHandler = () => {
    setShowAImodal(true);
  };

  const deleteFile = (newReponses?: any) => {
    let questionsData = questionnaireData
    if(newReponses){
         questionsData = newReponses
    }
    questionsData
      .filter((m: Question) => questionIds.includes(m.questionId))
      ?.map((n: Question) => {
        let filePath = null;
        if (n.answers && n.answers.length > 0) {
          if (typeof n.answers[0].answer === "object") {
            const ans: any = n.answers[0].answer;
            filePath = ans?.filePath;
          } else if (typeof n.answers[0].answer === "string") {
            const ans = ParseJson(n.answers[0].answer);
            filePath = ans?.filePath;
          }

          service
            .deleteClientFile(n.clientQuestionId, filePath, clientProductsId)
            .catch((error: AxiosError) => {
              catchError(error, true);
            });
        }
      });
  };

  // const checkForAnsweredQuestionValidation = (question: Question) => {
  //   if (question.questionId === questionId && question.answers) {
  //     if (
  //       parseInt(question?.answers[0].answer.slice(1).split(",").join("")) <
  //       averageAmount
  //     ) {
  //       const questions = questionnaireData.filter(
  //         (m: any) => !questionIds.includes(m.questionId)
  //       );

  //       deleteFile();
  //       setTimeout(() => {
  //         setQuestionnaireData(questions);
  //         setrefreshQuestionsData(true);
  //       }, 500);
  //     } else if (
  //       parseInt(question.answers[0].answer.slice(1).split(",").join("")) >=
  //       averageAmount
  //     ) {
  //       const questionsData = questionnaireData;

  //       filteredQuestions?.map((m: Question) => {
  //         if (questionnaireData.includes(m)) {
  //           return null;
  //         } else {
  //           m.answers = [];
  //           return questionsData.push(m);
  //         }
  //       });
  //       setTimeout(() => {
  //         setQuestionnaireData(questionsData);
  //         setrefreshQuestionsData(true);
  //       }, 500);
  //     }
  //   }
  // };

  const onSaveQuestion = (question: Question, oldAnswer: any) => {
    setrefreshQuestionsData(false);
    if (question.questionId === questionId && question.answers)
      if( parseInt(question?.answers[0].answer.slice(1).split(",").join(""))<averageAmount){
        const questions=questionnaireData.filter((m:any)=>!questionIds.includes(m.questionId));
        deleteFile();
        setTimeout(()=>{setQuestionnaireData(questions);setrefreshQuestionsData(true)},500)
      }else if(parseInt(question.answers[0].answer.slice(1).split(",").join(""))>=averageAmount){
        const questionsData =  questionnaireData;

        filteredQuestions?.map((m:Question)=>{
            if(questionnaireData.includes(m)){
              return null
            }
            else{
              m.answers=[]
              return questionsData.push(m)
            }
        })
        setTimeout(()=>{setQuestionnaireData(questionsData);setrefreshQuestionsData(true)},500);
      }

      // checkForAnsweredQuestionValidation(question);

    setQuestion(question);
    if (
      question.answers &&
      question.answers?.length > 0 &&
      question.answers[0].answer !== ""
    ) {
      if (
        question.questionType == QuestionTypes.FileUpload &&
        question.answers
      ) {
        const fileObj = question.answers[0].answer;
        setLoader(true);
        service
          .validationByAi(question.answers[0].answer, question.clientQuestionId)
          .then((response: any) => {
            if (response.data.status == true) {
              const aiOverride = false;
              service
                .postFileForClientPortal(
                  fileObj,
                  question.clientQuestionId,
                  aiOverride
                )
                .then((res: any) => {
                  const allQuestions = Object.assign([], questionnaireData);
                  const currentQuestion = allQuestions.find(
                    (m: any) => m.clientQuestionId == question.clientQuestionId
                  );
                  if (currentQuestion) {
                    currentQuestion.answers = [
                      { answer: res.data, optionId: null },
                    ];
                    setQuestionnaireData(allQuestions);
                    setrefreshQuestionsData(true);
                  }
                })
                .finally(() => {
                  setLoader(false);
                });
            } else {
              modalViewHandler();
              setLoader(false);
            }
          })
          .catch((error: AxiosError) => {
            catchError(error, true);
            modalViewHandler();
            setLoader(false);
          });
      } else {
        saveClientResponse(question);
      }
    } else {
      // remove the response
      if (question.questionType !== QuestionTypes.FileUpload) {
        removeResponses(question.clientQuestionId);
      } else {
        if (
          oldAnswer[question.clientQuestionId] &&
          oldAnswer[question.clientQuestionId].length > 0
        ) {
          // eslint-disable-next-line no-var
          var filePath = null;
          //for removing the dependent question answer
          if (
            oldAnswer[question.clientQuestionId][0].answer &&
            typeof oldAnswer[question.clientQuestionId][0].answer === "string"
          ) {
            const fileObj = ParseJson(
              oldAnswer[question.clientQuestionId][0].answer
            );
            if (fileObj && fileObj.filePath) {
              filePath = fileObj.filePath;
            }
          } else if (
            oldAnswer[question.clientQuestionId][0].answer &&
            typeof oldAnswer[question.clientQuestionId][0].answer === "object"
          ) {
            const fileObj = oldAnswer[question.clientQuestionId][0].answer;
            if (fileObj && fileObj.filePath) {
              filePath = fileObj.filePath;
            }
          } else if (
            typeof oldAnswer[question.clientQuestionId][0] === "object"
          ) {
            // for delete on click of delete button
            filePath = oldAnswer[question.clientQuestionId][0].filePath;
          }
          service
            .deleteClientFile(
              question.clientQuestionId,
              filePath,
              clientProductsId
            )
            .catch((error: AxiosError) => {
              catchError(error, true);
            });
        }
      }
    }
  };

  const closeModalViewHandler = () => {
    setShowAImodal(false);
    const allQuestions = Object.assign([], questionnaireData);
    const currentQuestion = allQuestions.questions.find(
      (m: Question) => m.clientQuestionId == question?.clientQuestionId
    );
    if (currentQuestion) {
      currentQuestion.answers = [];
      setQuestionnaireData(allQuestions);
      setrefreshQuestionsData(true);
    }
    setTimeout(() => {
      setrefreshQuestionsData(false);
    }, 300);
    setTimeout(() => {
      const allQuestion = Object.assign([], questionnaireData);
      const CurrentQuestion = allQuestion.questions.find(
        (m: Question) => m.clientQuestionId == question?.clientQuestionId
      );
      if (CurrentQuestion) {
        CurrentQuestion.answers = null;
        setQuestionnaireData(allQuestion);
        setrefreshQuestionsData(true);
      }
    }, 500);
  };
  const uploadFileHandler = () => {
    if (
      question?.answers &&
      question.answers?.length > 0 &&
      question.answers[0].answer !== ""
    ) {
      const fileObj = question?.answers[0].answer;
      setLoader(true);
      const aiOverride = true;
      service
        .postFile(fileObj, question?.clientQuestionId, aiOverride)
        .then((response: any) => {
          if (response.status == 200) {
            setShowAImodal(false);
          }
          const allQuestions = questionnaireData;
          const currentQuestion = allQuestions?.find(
            (m: Question) => m.clientQuestionId == question.clientQuestionId
          );
          if (currentQuestion) {
            currentQuestion.answers = [
              { answer: response.data, optionId: null },
            ];
            setQuestionnaireData(allQuestions);
            setrefreshQuestionsData(true);
          }
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };

  const removeResponses = (clientQuestionId: number) => {
    service
      .removeResponses(clientQuestionId)
      .catch((error) => catchError(error, true));
  };

  // const onSaveQuestion = (question: Question, oldAnswer: any) => {
  //   if (
  //     question?.answers &&
  //     question?.answers?.length > 0 &&
  //     question?.answers?.[0]?.answer !== ""
  //   ) {
  //     saveClientResponse(question);
  //   } else {
  //     if (question?.clientQuestionId) {
  //       removeResponses(question.clientQuestionId);
  //     }
  //   }
  // };

  useEffect(() => {
    getQuestions();
  }, [getQuestions]);

  const handleSaveQuestionnaire = () => {
    const selectedButtonRaw = sessionStorage.getItem("selectedButton");
    if (selectedButtonRaw) {
      const selectedButton: IActionBtnsModel = JSON.parse(selectedButtonRaw);
      if (
        bankuserDetails?.organization?.orgId &&
        clientId &&
        clientProductsId &&
        selectedButton?.moveToStatus
      ) {
        setLoader(true);
        const payload = {
          sections: "changeClientStatus",
          workflowRelated: true,
          orgId: bankuserDetails?.organization?.orgId,
          clientProductsId: clientProductsId,
          clientId: clientId,
          moveToStatus: selectedButton?.moveToStatus,
          businessTypeFlag: type === QUESTIONNAIRE_TYPES.DDA ? true : false,
        };
        service
          .updateEntity(payload)
          .then(() => navigate(-1))
          .catch((err) => catchError(err, true))
          .finally(() => setLoader(false));
      } else catchErrorGeneric("Something went wrong");
      // toast.error('Something went wrong')
    } else catchErrorGeneric("Something went wrong");
    // toast.error('Something went wrong')
  };

  const saveQuestionnaire = {
    displaySaveQuestionnaire: true,
    handleSaveQuestionnaire: handleSaveQuestionnaire,
    saveQuestionnaireLabel: "Submit",
  };

  const openFileViewHandler = () => setfileHandleModal(!fileHandleModal);

  const fileClick = (file: any) => {
    setLoader(true);
    service
      .getFile(file?.filePath)
      .then((response: any) => {
        if (response.data) {
          const data = { ...response.data, uri: response.data.fileContent };

          setFile(data);
        }
        openFileViewHandler();
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const disableFieldValue = () => {
    const editable = edit?.editable && edit?.editable;
    if (editable === true || editable === false) {
      return !editable;
    } else {
      return false;
    }
  };

  const getQuestionnarieType = () => {
    if (type === QUESTIONNAIRE_TYPES.CONTRACT) {
      return "Contract";
    } else if (type === QUESTIONNAIRE_TYPES.NDA) {
      return "NDA";
    } else if (type === QUESTIONNAIRE_TYPES.DDA) {
      return "DDA";
    } else if (type === QUESTIONNAIRE_TYPES.PAYMENT) {
      return "Payment";
    }
  };

  return (
    <div className="subCategoryContainer">
      {loader ? <FinSpinner /> : <></>}
      {/* {JSON.stringify(questionnaireData)} */}
      <div className="headingContainer">
        <div className="subCategoryHeader">
          <img
            src={backArrow}
            alt="backButton"
            className="back-icon"
            onClick={() => navigate(-1)}
          />
          {getQuestionnarieType()} Details
        </div>
      </div>
      <div className="px-3 text-right indicate-required">
        <span className="input-required"> *</span> indicates required
        information
      </div>
      <div className="subCategory">
        <div className="QuestionnarieReviewWrap m-0">
          <QuestionnaireComponent
            onNextPage={undefined}
            onPreviousPage={undefined}
            displayNextPrevButtons={false}
            questionsData={questionnaireData || []}
            refreshQuestionsData={refreshQuestionsData}
            // disableFields={edit?.isEditable? !edit?.isEditable : false}
            disableFields={disableFieldValue()}
            canAddGroupQuestions={false}
            onAddGroupQuestion={function (
              questionGroupUuid: any,
              currentSerialNumber: any
            ): void {
              throw new Error("Function not implemented.");
            }}
            onRemoveGroupQuestion={function (
              questionGroupUuid: any,
              selectedSerialNumber: any
            ): void {
              throw new Error("Function not implemented.");
            }}
            formName={"QuestionnaireForm"}
            onSaveQuestion={onSaveQuestion}
            saveQuestionnaire={saveQuestionnaire}
            onClickFile={fileClick}
          />
        </div>
      </div>
      <div className="AIModalPopUpContainer">
        <Modal
          className="popup-modal"
          size="md"
          isOpen={showAIModal}
          fade={false}
          toggle={modalViewHandler}
        >
          <ModalHeader toggle={closeModalViewHandler}>
            <span className="headerText">Is this the correct document?</span>
          </ModalHeader>
          <ModalBody>
            <div className="bodyText">
              <span className="ourSystemText">
                Our system isn’t sure this is correct.{" "}
              </span>
              <br />
              <span className="areYouSureText">
                Are you sure this is the {[question?.questionText]}
              </span>
            </div>
            <div className="modalBtnsDiv">
              <button onClick={closeModalViewHandler} className="noUploadBtn">
                No, upload a different file
              </button>
              <button onClick={uploadFileHandler} className="yesUploadBtn">
                Yes, attach this document
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>

      <div className="fileViewerModalContainer">
        <Modal
          className=" mw-100 w-50 fileViewerModalWrapper"
          isOpen={fileHandleModal}
          fade={false}
          toggle={openFileViewHandler}
        >
          <ModalHeader toggle={openFileViewHandler} className="tc_heading">
            <span>{file?.fileName} </span>
          </ModalHeader>
          <ModalBody>
            <div className="TC_fileView">
              {loader ? (
                <FinSpinner />
              ) : file ? (
                <ReactFileViewer fileDocument={file} />
              ) : (
                ""
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
}
